import { nextTick } from 'vue';
import { createI18n } from 'vue-i18n';
import { useGlobalStore } from '@/stores';

export const languages = [
    { short: 'cs', label: 'Čeština', value: 'cs-CZ' },
    { short: 'de', label: 'Deutsch', value: 'de-DE' },
    { short: 'en', label: 'English (United Kingdom)', value: 'en-GB' },
    { short: 'en_US', label: 'English (United States)', value: 'en-US' },
    { short: 'es', label: 'Español', value: 'es-ES' },
    { short: 'fr', label: 'Français', value: 'fr-FR' },
    { short: 'it', label: 'Italiano', value: 'it-IT' },
    { short: 'ja', label: '日本語', value: 'ja-JP' },
    { short: 'nl', label: 'Nederlands', value: 'nl-NL' },
    { short: 'pl', label: 'Polski', value: 'pl-PL' },
    { short: 'pt', label: 'Português (Portugal)', value: 'pt-PT' },
    { short: 'pt_BR', label: 'Português (Brasil)', value: 'pt-BR' },
    { short: 'ro', label: 'Românește', value: 'ro-RO' },
    { short: 'sk', label: 'Slovenčina', value: 'sk-SK' },
];

let source = {};
const SUPPORT_LOCALES = languages.map((lang) => lang.value);

// Import the application's language controller
const i18n = createI18n({
    allowComposition: true,
    locale: '', // set locale
});

const getLongLocale = (locale) => {
    locale = locale.replace('_', '-');
    if (locale.length > 2 && !SUPPORT_LOCALES.includes(locale)) {
        locale = locale.substring(0, 2);
    }

    if (locale.length === 2) {
        if (locale === 'en') {
            locale = 'en-GB';
        } else if (locale === 'cs') {
            locale = 'cs-CZ';
        } else if (locale === 'ja') {
            locale = 'ja-JP';
        } else {
            locale = locale + '-' + locale.toUpperCase();
        }
    }

    return locale;
};

export const findLocale = (requestLocale, defaultLocale) => {
    let locale = getLongLocale(defaultLocale);
    if (requestLocale) {
        locale = requestLocale;
    } else if (localStorage.user_lang) {
        locale = localStorage.user_lang;
    } else if (localStorage['iso_639-1_lang']) {
        locale = localStorage['iso_639-1_lang'].replace('_', '-');
    }

    locale = getLongLocale(locale);
    if (SUPPORT_LOCALES.includes(locale)) {
        return locale;
    }

    return getLongLocale(defaultLocale);
};

const loadLocaleMessages = async (locale, overrides) => {
    // eslint-disable-next-line no-undef
    const prefix = __webpack_public_path__;
    const response = await fetch(prefix + `locales/${locale}.json`);
    if (response && response.status !== undefined && response.status === 200) {
        const json = await response.json();
        let messages = { ...json, ...overrides };

        // eslint-disable-next-line no-undef
        if (!['production', 'test'].includes(process.env.NODE_ENV)) {
            if (Object.keys(source).length === 0) {
                const response2 = await fetch(prefix + 'locales/source.json');
                if (response2 && response2.status !== undefined && response2.status === 200) {
                    source = await response2.json();
                }
            }

            messages = { ...source, ...messages };
        }

        i18n.global.setLocaleMessage(locale, messages);
    }

    return nextTick();
};

export const setLocale = async (locale, overrides = {}) => {
    if (!i18n.global.availableLocales.includes(locale)) {
        await loadLocaleMessages(locale, overrides);
    }
    if (i18n.mode === 'legacy') {
        i18n.global.locale = locale;
    } else {
        i18n.global.locale.value = locale;
    }

    const short = languages.find((x) => x.value === locale).short;
    localStorage['iso_639-1_lang'] = short;
    localStorage.user_lang = locale;
    const store = useGlobalStore();
    store.setRequestParams({ ...store.requestParams, lang: short });
};

export default i18n;
